module.exports = __webpack_public_path__ + "static/img/icon2.bc905093.png";